import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Typography, Button, Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  hero: {
    position: "relative",
    minHeight: "600px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    color: "#ffffff",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      minHeight: "500px",
    },
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1,
  },
  content: {
    position: "relative",
    zIndex: 2,
    textAlign: "center",
    maxWidth: 800,
    padding: theme.spacing(4),
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    fontSize: "3rem",
    lineHeight: 1.2,
    textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
    [theme.breakpoints.down("md")]: {
      fontSize: "2.5rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  subtitle: {
    fontSize: "1.5rem",
    marginBottom: theme.spacing(4),
    fontWeight: 400,
    lineHeight: 1.5,
    textShadow: "1px 1px 2px rgba(0,0,0,0.3)",
    [theme.breakpoints.down("md")]: {
      fontSize: "1.25rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1rem",
    },
  },
  ctaButton: {
    padding: theme.spacing(1.5, 4),
    fontSize: "1.1rem",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: 8,
    boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
    },
  },
  ctaPrimary: {
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  ctaSecondary: {
    backgroundColor: "#ffffff",
    color: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
}));

const HeroSection = ({ title, subtitle, backgroundImage, cta }) => {
  const classes = useStyles();

  const handleCtaClick = () => {
    if (cta.url.startsWith("#")) {
      const element = document.querySelector(cta.url);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else if (cta.url.startsWith("/")) {
      window.location.href = cta.url;
    } else {
      window.open(cta.url, "_blank", "noopener,noreferrer");
    }
  };

  const buttonClass = cta.style === "secondary" ? classes.ctaSecondary : classes.ctaPrimary;

  return (
    <Box
      className={classes.hero}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className={classes.overlay} />
      <Container className={classes.content}>
        <Typography variant="h1" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="h5" className={classes.subtitle}>
          {subtitle}
        </Typography>
        <Button
          variant="contained"
          size="large"
          className={`${classes.ctaButton} ${buttonClass}`}
          onClick={handleCtaClick}
        >
          {cta.text}
        </Button>
      </Container>
    </Box>
  );
};

export default HeroSection;
